import { gql, TypedDocumentNode } from "@apollo/client";

import {
  MutationStackScheduledTaskCreateArgs,
  ScheduledTask,
  ScheduledTaskInput,
} from "types/generated";

type StackSchedulingTaskCreateData = {
  stackScheduledTaskCreate: Pick<ScheduledTask, "id">;
};

export const CREATE_STACK_SCHEDULING_TASK: TypedDocumentNode<
  StackSchedulingTaskCreateData,
  MutationStackScheduledTaskCreateArgs
> = gql`
  mutation StackSchedulingTaskCreate($stack: ID!, $input: ScheduledTaskInput!) {
    stackScheduledTaskCreate(stack: $stack, input: $input) {
      id
    }
  }
`;

type StackSchedulingTaskUpdateData = {
  stackScheduledTaskUpdate: Pick<ScheduledTask, "id">;
};

type StackSchedulingTaskUpdateVariables = {
  scheduleId: string;
  stack: string;
  input: ScheduledTaskInput;
};

export const UPDATE_STACK_SCHEDULING_TASK: TypedDocumentNode<
  StackSchedulingTaskUpdateData,
  StackSchedulingTaskUpdateVariables
> = gql`
  mutation StackSchedulingTaskUpdate($scheduleId: ID!, $stack: ID!, $input: ScheduledTaskInput!) {
    stackScheduledTaskUpdate(scheduledTask: $scheduleId, stack: $stack, input: $input) {
      id
    }
  }
`;

type StackSchedulingTaskDeleteData = {
  stackScheduledTaskDelete: Pick<ScheduledTask, "id"> | null;
};

type StackSchedulingTaskDeleteVariables = {
  scheduleId: string;
  stack: string;
};

export const DELETE_STACK_SCHEDULING_TASK: TypedDocumentNode<
  StackSchedulingTaskDeleteData,
  StackSchedulingTaskDeleteVariables
> = gql`
  mutation StackSchedulingTaskDelete($scheduleId: ID!, $stack: ID!) {
    stackScheduledTaskDelete(scheduledTask: $scheduleId, stack: $stack) {
      id
    }
  }
`;
